import { render, staticRenderFns } from "./ProjectsIndex.vue?vue&type=template&id=eef2dd28&"
import script from "./ProjectsIndex.vue?vue&type=script&lang=js&"
export * from "./ProjectsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports